import React, { useEffect, useState, useContext, useRef } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Avatar,
  IconButton,
  AppBar,
  Toolbar,
  Card,
  CardContent,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import EditIcon from "@mui/icons-material/Edit";
import { AuthContext } from "../../AuthContext/AuthContext";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../Api/ApiUrls";
import FormsBottomNavbar from "./../Post Module/FormsBottomNavbar";

const EditProfile = () => {
  const navigate = useNavigate();
  const { userId } = useContext(AuthContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    mobile_no: "",
    city: "",
    state: "",
    profile: null,
  });

  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    if (!userId) return;

    fetch(`${BASE_URL}/users/${userId}/`)
      .then((res) => res.json())
      .then((data) => {
        setFormData({
          username: data.username || "",
          email: data.email || "",
          mobile_no: data.mobile_no || "",
          city: data.city || "",
          state: data.state || "",
          profile: data.profile || null,
        });
        if (data.profile) {
          setPreviewImage(`${BASE_URL}${data.profile}`);
        }
      })
      .catch((err) => console.error("Failed to fetch user:", err));
  }, [userId]);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Create preview URL
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);

      // Update form data
      setFormData((prev) => ({
        ...prev,
        profile: file,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("Submitting form with data:", formData);

    const formDataToSend = new FormData();
    formDataToSend.append("username", formData.username);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("mobile_no", formData.mobile_no);
    formDataToSend.append("city", formData.city);
    formDataToSend.append("state", formData.state);

    if (formData.profile && typeof formData.profile !== "string") {
      formDataToSend.append("profile", formData.profile);
      console.log("Appended profile image to FormData");
    } else {
      console.log("No new profile image selected");
    }

    try {
      console.log("Sending PUT request to:", `${BASE_URL}/users/${userId}/`);
      const response = await fetch(`${BASE_URL}/users/${userId}/`, {
        method: "PUT",
        body: formDataToSend,
      });

      console.log("Response status:", response.status);

      if (response.ok) {
        const data = await response.json();
        console.log("Update successful:", data);
        alert("Profile updated successfully!");
        navigate(`/user-profile/${userId}`);
      } else {
        const errorData = await response.text();
        console.error("Update failed:", errorData);
        throw new Error("Update failed");
      }
    } catch (err) {
      console.error("Error updating profile:", err);
      alert("Something went wrong.");
    }
  };


  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        background: `
          linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
          url('/construction4.png')
        `,
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        pb: 7,
      }}
    >
      {/* AppBar Header */}
      <AppBar
        position="static"
        elevation={0}
        sx={{
          background: `
                 linear-gradient(145deg,rgb(22, 22, 22),rgb(15, 15, 15)),
                 url('/construction5.png')
               `,
          color: 'text.primary',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}
      >
        <Toolbar sx={{ minHeight: 64 }}>
          <IconButton
            edge="start"
            onClick={() => navigate(-1)}
            sx={{
              color: '#ffffff',
              backgroundColor: 'rgba(255,255,255,0.1)',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.2)'
              }
            }}
          >
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1, ml: 2, color: 'white' }}>
            Edit Profile
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Form Card */}
      <Container sx={{ py: 2, flex: 1, px: isMobile ? 1 : 2 }}>
        <Card sx={{ borderRadius: "12px", boxShadow: 3 }}>
          <CardContent sx={{ p: isMobile ? 1 : 2 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                p: isMobile ? 1 : 2,
                mb: isMobile ? 0 : 1,
                position: "relative",
              }}
            >
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleImageChange}
                accept="image/*"
                style={{ display: "none" }}
              />
              <Avatar
                alt={formData.username || "User"}
                // src={
                //   previewImage ||
                //   (formData.profile
                //     ? `${BASE_URL}${formData.profile}`
                //     : "https://randomuser.me/api/portraits/women/44.jpg")
                // }
                src={
                  previewImage
                    ? previewImage
                    : formData?.profile
                      ? `${BASE_URL}${formData.profile}`
                      : ""
                }
                sx={{
                  width: isMobile ? 100 : 120,
                  height: isMobile ? 100 : 120,
                  border: "3px solid white",
                  boxShadow: 2,
                }}
              />
              <IconButton
                onClick={triggerFileInput}
                sx={{
                  position: "absolute",
                  bottom: 0,
                  right: isMobile ? "calc(50% - 60px)" : "calc(50% - 70px)",
                  backgroundColor: "primary.main",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "primary.dark",
                  },
                }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
              <Typography variant={isMobile ? "subtitle1" : "h6"} sx={{ fontWeight: "bold", mt: 2 }}>
                {formData.username || "Edit Profile"}
              </Typography>
            </Box>

            <Divider sx={{ my: isMobile ? 1 : 2 }} />

            <form onSubmit={handleSubmit}>
              <TextField
                label="Username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                fullWidth
                margin="normal"
                size={isMobile ? "small" : "medium"}
                required
              />
              <TextField
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                fullWidth
                margin="normal"
                size={isMobile ? "small" : "medium"}
                required
              />
              <TextField
                label="Mobile Number"
                name="mobile_no"
                value={formData.mobile_no}
                onChange={handleChange}
                fullWidth
                margin="normal"
                size={isMobile ? "small" : "medium"}
                required
              />
              <TextField
                label="City"
                name="city"
                value={formData.city}
                onChange={handleChange}
                fullWidth
                margin="normal"
                size={isMobile ? "small" : "medium"}
                required
              />
              <TextField
                label="State"
                name="state"
                value={formData.state}
                onChange={handleChange}
                fullWidth
                margin="normal"
                size={isMobile ? "small" : "medium"}
                required
              />

              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{
                  mt: 2,
                  mb: 1,
                  borderRadius: "8px",
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? "0.875rem" : "1rem",
                }}
              >
                Save Changes
              </Button>
            </form>
          </CardContent>
        </Card>
      </Container>

      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: theme.zIndex.appBar,
        }}
      >
        <FormsBottomNavbar />
      </Box>
    </Box>
  );
};

export default EditProfile;